import script from "./WorkbookCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkbookCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./WorkbookCreateForm.vue?vue&type=style&index=0&id=9d520f14&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d520f14"]])

export default __exports__